export enum CvDistributionStatus {
     None = 0,
     Success = 1,
     Duplicate = 2,
     Failed = 3
}